import Vue from 'vue';
import VueRouter from 'vue-router';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import store from '../store';
import constants from '../plugins/constants';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import base from '../views/base.vue';

Vue.use(VueRouter);
Vue.use(PerfectScrollbar);

const routes = [
  {
    path: '',
    component: base,
    meta: {noauth: true}
  },
  {
    // Discover / dedicated deep links use /login; App shows Login when unauthenticated
    path: '/login',
    redirect: (to) => ({ path: '/', query: to.query, hash: to.hash }),
  },
  {
    path: '/setpassword',
    meta: { color: "primary", noauth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/Auth/SetPassword.vue'),
  },
  {
    path: '/setnewpassword',
    meta: { color: "primary", noauth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/Auth/SetNewPassword.vue'),
  },
  {
    path: '/forgotpassword',
    meta: { color: "primary", noauth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/Auth/ForgotPassword.vue'),
  },
  {
    path: constants.SSO.CALLBACK_PATH,
    meta: { color: "primary", noauth: true },
    component: () => import(/* webpackChunkName: "auth-sso" */ '../views/Auth/SsoCallback.vue'),
  },
  {
    path: constants.SSO.LOGOUT_COMPLETE_PATH,
    meta: { color: "primary", noauth: true },
    component: () => import(/* webpackChunkName: "auth-sso" */ '../views/Auth/LogoutComplete.vue'),
  },
  {
    path: '/selfservice',
    meta: { color: "primary", noauth: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/Auth/SelfService.vue'),
  },
  {
    path: '/error',
    component: base,
    children: [
      getRouteData("UCP", [], "404", 'views/common/NoAccess.vue', {}, () => {
        store.commit("setNewMenu", []);
      }),
      // {
      //   path: '404',
      //   component: function() {
      //     store.commit("setNewMenu", []);
      //     return import(/* webpackChunkName: "about" */ '../views/common/NoAccess.vue');
      //   },
      // },
    ],
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const APP_TITLE = constants.APP.TITLE;

function getDocumentTitle(route) {
  const matchedRoute = (route?.matched || [])
    .slice()
    .reverse()
    .find(record => typeof record?.meta?.title === 'string' && record.meta.title.trim());

  const pageTitle = matchedRoute?.meta?.title?.trim();

  return pageTitle ? `${pageTitle} | ${APP_TITLE}` : APP_TITLE;
}

function syncDocumentTitle(route) {
  if (typeof document === 'undefined') return;

  document.title = getDocumentTitle(route);
}


router.afterEach((to) => {
  syncDocumentTitle(to);
});

router.onReady(() => {
  syncDocumentTitle(router.currentRoute);
});

function getView(p, view, moduleName) {
  // console.log(p, store.state.subscriptions);
  // console.log(import("./modules/" + view),"SSSSSS");
  // console.log(store.state.subscriptions, subscription, p, allow, process.env.VUE_APP_IGNORE_SUBSCRIPTIONS);
  if(view === "__base") return import('../views/base.vue');
  else if(view === "") return import('../views/common/NoAccess.vue');
  else if(view.indexOf("common/") > -1) { return import(/* webpackInclude: /\.vue$/ */ "../views/" + view);}
  else return import(
    /* webpackInclude: /\.vue$/ */
    /* webpackExclude: /\.md$/ */
    "../modules/" + moduleName + "/views/" + view
  );
}

function getRouteData(moduleName, p, path, view = "", meta = {}, cfun = () => { }, noaccess = false) {
  cfun();
  let v = view;
  if (noaccess) {
    store.commit("setNewMenu", []);
    v = "";
  }
  let d = {
    path: path,
    component: () => {
      // console.log('---> initial path: ', path);
      return getView(p, v, moduleName);
    },
    meta: meta,
  };
  if (["risk"].indexOf(p) > -1) d.meta.color = "crisk";
  else if (["compliance"].indexOf(p) > -1) d.meta.color = "ccompliance";
  else if (["accounting"].indexOf(p) > -1) d.meta.color = "caccounting";
  else if (["transaction"].indexOf(p) > -1) d.meta.color = "ctransaction";
  else if (["ucp", "others"].indexOf(p) > -1) d.meta.color = "primary";
  else d.meta.color = "primary";
  return d;
}

export default {router, getRouteData}
